<app-page-breadcrumb pageTitle="Empresas"></app-page-breadcrumb>

<div class="space-y-4">
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <div class="flex items-center gap-1.5"></div>

    <div class="flex items-center gap-1.5">
      <button
        type="button"
        (click)="toggleFilters()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z">
          </path>
        </svg>
        {{ showFilters ? 'Ocultar' : 'Filtros' }}
      </button>

      <button
        *appHasPermission="'settings:create'"
        type="button"
        (click)="nuevoBusiness()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
        </svg>
        Nuevo
      </button>
    </div>
  </div>

  @if (showFilters) {
    <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-3">
        <div class="lg:col-span-2">
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Buscar por nombre o número de identificación
          </label>
          <input
            type="text"
            [(ngModel)]="filtroNombre"
            (ngModelChange)="buscar()"
            placeholder="Ej: PartnerTech / 20-123..."
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Estado
          </label>
          <select
            [(ngModel)]="filtroActivo"
            (ngModelChange)="buscar()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
            <option [ngValue]="undefined">Todos</option>
            <option [ngValue]="true">Activos</option>
            <option [ngValue]="false">Inactivos</option>
          </select>
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Ordenar por
          </label>
          <select
            [(ngModel)]="sortBy"
            (ngModelChange)="buscar()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
            <option [ngValue]="'name'">Nombre</option>
            <option [ngValue]="'identification'">Número de Identificación</option>
          </select>
        </div>

        <div class="flex items-end gap-2">
          <button
            type="button"
            (click)="toggleSortDir()"
            class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 w-full">
            {{ sortDir === 'asc' ? 'Asc' : 'Desc' }}
          </button>

          <button
            type="button"
            (click)="limpiarFiltro()"
            class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 w-full">
            Limpiar
          </button>
        </div>
      </div>
    </div>
  }

  @if (loading) {
    <div class="flex justify-center items-center py-12">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
      <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando businesses...</span>
    </div>
  }

  @if (error) {
    <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
      <div class="flex items-center gap-3">
        <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <p class="text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
    </div>
  }

  @if (!loading && !error) {
    <div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
      <div class="max-w-full overflow-x-auto custom-scrollbar">
        <table class="min-w-full">
          <thead class="border-b border-gray-100 dark:border-white/[0.05]">
            <tr>
              <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Nombre</th>
              <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Número de Identificación</th>
              <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Teléfono</th>
              <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Dirección</th>
              <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Estado</th>
              <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
            </tr>
          </thead>

          <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
            @if (businesses.length === 0) {
              <tr>
                <td colspan="6" class="px-5 py-8 text-center">
                  <div class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400">
                    <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                        d="M3 21V5a2 2 0 012-2h14a2 2 0 012 2v16M7 7h10M7 11h10M7 15h6">
                      </path>
                    </svg>
                    <span>No hay businesses para mostrar</span>
                  </div>
                </td>
              </tr>
            }

            @for (b of businesses; track b.id) {
              <tr>
                <td class="px-4 py-3 text-start">
                  <span class="block font-medium text-gray-800 dark:text-white/90">
                    {{ b.name }}
                  </span>
                  @if (b.description) {
                    <span class="block text-xs text-gray-400 dark:text-gray-500 truncate max-w-[420px]">
                      {{ b.description }}
                    </span>
                  }
                </td>

                <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                  @if (b.identificationType && b.identificationNumber) {
                    <span class="text-gray-400 dark:text-gray-500">{{ b.identificationType }}</span>
                  }
                  {{ b.identificationNumber || '-' }}
                </td>

                <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                  {{ b.phone || '-' }}
                </td>

                <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                  <span class="block truncate max-w-[380px]">
                    {{ b.address || '-' }}
                  </span>
                </td>

                <td class="px-4 py-3 text-start">
                  <button
                    type="button"
                    (click)="toggleActivo(b)"
                    [appDisableWithoutPermission]="'settings:edit'"
                    [disabled]="esProveedora(b)"
                    [title]="esProveedora(b)
                      ? 'La empresa proveedora no se puede desactivar'
                      : ((b.isActive ?? false) ? 'Clic para desactivar' : 'Clic para activar')"
                    class="inline-flex items-center gap-2 transition-opacity"
                    [class.opacity-50]="togglingId === b.id"
                    [class.cursor-not-allowed]="esProveedora(b)"
                    [class.pointer-events-none]="togglingId === b.id">
                    <span
                      class="relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors"
                      [class.bg-success-500]="b.isActive ?? false"
                      [class.bg-gray-300]="!(b.isActive ?? false)"
                      [class.dark:bg-gray-600]="!(b.isActive ?? false)">
                      <span
                        class="inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform"
                        [class.translate-x-4]="b.isActive ?? false"
                        [class.translate-x-0.5]="!(b.isActive ?? false)"></span>
                    </span>
                    <span
                      class="text-theme-sm font-medium"
                      [class.text-success-600]="b.isActive ?? false"
                      [class.dark:text-success-400]="b.isActive ?? false"
                      [class.text-gray-500]="!(b.isActive ?? false)"
                      [class.dark:text-gray-400]="!(b.isActive ?? false)">
                      {{ getEstadoLabel(b) }}
                    </span>
                  </button>
                  @if (esProveedora(b)) {
                    <span
                      class="ml-2 inline-flex items-center rounded-full bg-brand-50 px-2 py-0.5 text-xs font-medium text-brand-600 dark:bg-brand-500/15 dark:text-brand-400"
                      title="Empresa proveedora del CRM: siempre activa, no se puede desactivar ni eliminar">
                      Proveedor
                    </span>
                  }
                </td>

                <td class="px-4 py-3 text-center">
                  <div class="flex items-center justify-center gap-2">
                    <button
                      type="button"
                      (click)="verBusiness(b)"
                      class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors"
                      title="Ver">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    </button>

                    <button
                      type="button"
                      (click)="editarBusiness(b)"
                      [appDisableWithoutPermission]="'settings:edit'"
                      class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors"
                      title="Editar">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                        </path>
                      </svg>
                    </button>

                    <button
                      type="button"
                      (click)="eliminarBusiness(b)"
                      [appDisableWithoutPermission]="'settings:delete'"
                      [disabled]="esProveedora(b)"
                      [class.opacity-40]="esProveedora(b)"
                      [class.cursor-not-allowed]="esProveedora(b)"
                      class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 transition-colors"
                      [title]="esProveedora(b) ? 'La empresa proveedora no se puede eliminar' : 'Eliminar'">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                        </path>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      @if (globalTotalPages >= 1) {
      <div class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4 px-5 pb-4">
        <div class="flex items-center justify-between gap-4 flex-wrap">
          <div class="flex items-center gap-2">
            <span class="text-sm text-gray-500 dark:text-gray-400">{{ globalTotalElements }} registros</span>
            <select [ngModel]="pageSize" (ngModelChange)="changePageSize($event)"
              class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                     bg-white dark:bg-gray-800 text-gray-900 dark:text-white
                     focus:ring-2 focus:ring-brand-500 focus:border-transparent">
              @for (opt of PAGE_SIZE_OPTIONS; track opt) {
                <option [value]="opt">{{ opt }}</option>
              }
            </select>
          </div>
          <div class="flex items-center gap-2">
            <button type="button" (click)="cambiarPagina(globalPage - 1)" [disabled]="!hasPrevPage"
              class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                     bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300
                     hover:bg-gray-50 dark:hover:bg-gray-700
                     disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
              Anterior
            </button>
            <div class="flex items-center gap-1.5">
              <span class="text-sm text-gray-500 dark:text-gray-400">Página</span>
              <select [ngModel]="pageDisplay" (ngModelChange)="cambiarPagina($event - 1)"
                class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                       bg-white dark:bg-gray-800 text-gray-900 dark:text-white
                       focus:ring-2 focus:ring-brand-500 focus:border-transparent">
                @for (p of pagesArray; track p) {
                  <option [value]="p">{{ p }}</option>
                }
              </select>
              <span class="text-sm text-gray-500 dark:text-gray-400">de {{ globalTotalPages }}</span>
            </div>
            <button type="button" (click)="cambiarPagina(globalPage + 1)" [disabled]="!hasNextPage"
              class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                     bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300
                     hover:bg-gray-50 dark:hover:bg-gray-700
                     disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
              Siguiente
            </button>
          </div>
        </div>
      </div>
      }
    </div>
  }

  <!-- Detalle estándar con tabs (Información + Línea de tiempo) — INC 18 -->
  <app-business-detail-modal
    [isOpen]="isDetailOpen"
    [business]="selectedBusiness"
    [detailLoading]="detailLoading"
    (close)="cerrarDetalle()"
    (edit)="editarBusiness($event)">
  </app-business-detail-modal>

  <!-- Eliminar negocio (inactivo) con contraseña — INC 16 -->
  <app-modal [isOpen]="showDeleteModal" (close)="cancelarEliminar()" className="max-w-md mx-4 sm:mx-6">
    @if (deleteTarget) {
      <div class="p-6">
        <div class="flex items-start gap-3 mb-4">
          <div class="flex items-center justify-center w-10 h-10 rounded-full bg-error-50 dark:bg-error-500/10 shrink-0">
            <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            </svg>
          </div>
          <div class="min-w-0">
            <h3 class="text-base font-semibold text-gray-900 dark:text-white">Eliminar negocio</h3>
            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
              Vas a eliminar <strong class="text-gray-700 dark:text-white/80">{{ deleteTarget.name }}</strong>.
              Esta acción no se puede deshacer. Ingresa tu contraseña para confirmar.
            </p>
          </div>
        </div>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Tu contraseña <span class="text-error-500">*</span>
          </label>
          <div class="relative">
            <input
              [type]="showDeletePassword ? 'text' : 'password'"
              [(ngModel)]="deletePassword"
              (ngModelChange)="deleteError = ''"
              (keyup.enter)="confirmarEliminar()"
              placeholder="••••••••"
              autocomplete="current-password"
              class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 pr-11 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
              [class.border-error-500]="deleteError"
              [class.border-gray-300]="!deleteError"
            />
            <button type="button" (click)="toggleDeletePassword()"
              class="absolute inset-y-0 right-0 flex items-center justify-center w-11 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-white/80"
              [attr.aria-label]="showDeletePassword ? 'Ocultar contraseña' : 'Mostrar contraseña'">
              @if (showDeletePassword) {
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13.875 18.825A10.05 10.05 0 0112 19c-5.523 0-10-4.477-10-10 0-1.04.158-2.043.45-2.986m3.11 5.062A3 3 0 0012 15a3 3 0 002.828-4M9.88 9.88A3 3 0 0114.12 14.12M6.228 6.228L3 3m18 18l-3.228-3.228M9.88 9.88L6.228 6.228m7.892 7.892l3.652 3.652" />
                </svg>
              } @else {
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              }
            </button>
          </div>
          @if (deleteError) {
            <p class="mt-1.5 text-sm text-error-500">{{ deleteError }}</p>
          }
        </div>

        <div class="flex items-center justify-end gap-2 pt-5">
          <button type="button" (click)="cancelarEliminar()" [disabled]="deleting"
            class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 disabled:opacity-50">
            Cancelar
          </button>
          <button type="button" (click)="confirmarEliminar()" [disabled]="deleting"
            class="inline-flex items-center gap-2 px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-error-500 text-white hover:bg-error-600 disabled:opacity-60">
            @if (deleting) {
              <span class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></span>
              Eliminando...
            } @else {
              Eliminar
            }
          </button>
        </div>
      </div>
    }
  </app-modal>
</div>
